import { Box } from '@glplus/glpweb-dsl';
import {
  storeTypeChip,
  stageChip,
  vendorStatusChip,
  type VendorAppStatus,
  type VendorStatus,
} from '../lib/vendorChips';

/** A custom-colored pill (DSL Chip only supports preset palettes). */
export function Pill({
  label,
  fg,
  bg,
  strong = false,
}: {
  label: string;
  fg: string;
  bg: string;
  strong?: boolean;
}) {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1,
        py: '2px',
        borderRadius: '10px',
        backgroundColor: bg,
        color: fg,
        fontSize: '11px',
        fontWeight: strong ? 700 : 600,
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Box>
  );
}

export function StoreChip({ businessType }: { businessType?: string | null }) {
  const c = storeTypeChip(businessType);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}

export function StageChip({ status }: { status: VendorAppStatus | string }) {
  const c = stageChip(status);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}

export function VendorStatusChip({ status }: { status: VendorStatus | string }) {
  const c = vendorStatusChip(status);
  return <Pill label={c.label} fg={c.fg} bg={c.bg} />;
}
